import { getSanitizedhighlightTextInput } from '../../textInput';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AutocompleteSuggestionTerm = styled.span.withConfig({
  displayName: "AutocompleteSuggestion__AutocompleteSuggestionTerm",
  componentId: "sc-1hdfo1l-0"
})(["color:", ";mark{font-weight:500;color:inherit;background-color:transparent;}"], ({
  theme
}) => theme.color['text-core-default']);
export const AutocompleteSuggestion = ({
  text,
  label,
  searchValue,
  onClick,
  render = content => content,
  noSuggestions
}) => {
  const sanitizedHighlightedText = getSanitizedhighlightTextInput(text, searchValue.trim());
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(View, {
      onClick: onClick,
      paddingInlineStart: noSuggestions ? '500' : undefined,
      children: render( /*#__PURE__*/_jsxs(TFlex, {
        paddingBlock: "200",
        children: [/*#__PURE__*/_jsx(AutocompleteSuggestionTerm, {
          dangerouslySetInnerHTML: {
            __html: sanitizedHighlightedText
          }
        }), /*#__PURE__*/_jsx(Text, {
          color: "text-core-default",
          children: label
        })]
      }))
    })
  );
};
export default AutocompleteSuggestion;